/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateScreencomponentDto } from '../models/work-create-screencomponent-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkScreencomponent } from '../models/work-screencomponent';
import { WorkUpdateScreencomponentDto } from '../models/work-update-screencomponent-dto';

@Injectable({ providedIn: 'root' })
export class WorkScreencomponentsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `screencomponentsV2ControllerFindAllPaginated()` */
  static readonly ScreencomponentsV2ControllerFindAllPaginatedPath = '/v2/screencomponents';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screencomponentsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  screencomponentsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by screenslideComponents.screenslideId query param.
     *           <p>
     *              <b>Format: </b> filter.screenslideComponents.screenslideId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.screenslideComponents.screenslideId=$not:$like:John Doe&filter.screenslideComponents.screenslideId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.screenslideComponents.screenslideId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkScreencomponent>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'screenslideComponents.screenslideId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreencomponentsV2Service.ScreencomponentsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.screenslideComponents.screenslideId', params['filter.screenslideComponents.screenslideId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkScreencomponent>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'screenslideComponents.screenslideId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screencomponentsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screencomponentsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by screenslideComponents.screenslideId query param.
     *           <p>
     *              <b>Format: </b> filter.screenslideComponents.screenslideId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.screenslideComponents.screenslideId=$not:$like:John Doe&filter.screenslideComponents.screenslideId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.screenslideComponents.screenslideId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkScreencomponent>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'screenslideComponents.screenslideId'?: (string | Array<string>);
};
};
}> {
    return this.screencomponentsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkScreencomponent>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'screenslideComponents.screenslideId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkScreencomponent>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'screenslideComponents.screenslideId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `screencomponentsV2ControllerCreate()` */
  static readonly ScreencomponentsV2ControllerCreatePath = '/v2/screencomponents';

  /**
   * Required permissions: screen:create, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screencomponentsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screencomponentsV2ControllerCreate$Response(
    params: {
      body: WorkCreateScreencomponentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreencomponent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreencomponentsV2Service.ScreencomponentsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreencomponent>;
      })
    );
  }

  /**
   * Required permissions: screen:create, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screencomponentsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screencomponentsV2ControllerCreate(
    params: {
      body: WorkCreateScreencomponentDto
    },
    context?: HttpContext
  ): Observable<WorkScreencomponent> {
    return this.screencomponentsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreencomponent>): WorkScreencomponent => r.body)
    );
  }

  /** Path part for operation `screencomponentsV2ControllerFindById()` */
  static readonly ScreencomponentsV2ControllerFindByIdPath = '/v2/screencomponents/{id}';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screencomponentsV2ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  screencomponentsV2ControllerFindById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreencomponent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreencomponentsV2Service.ScreencomponentsV2ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreencomponent>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screencomponentsV2ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screencomponentsV2ControllerFindById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkScreencomponent> {
    return this.screencomponentsV2ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreencomponent>): WorkScreencomponent => r.body)
    );
  }

  /** Path part for operation `screencomponentsV2ControllerDelete()` */
  static readonly ScreencomponentsV2ControllerDeletePath = '/v2/screencomponents/{id}';

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screencomponentsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  screencomponentsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreencomponentsV2Service.ScreencomponentsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screencomponentsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screencomponentsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.screencomponentsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `screencomponentsV2ControllerUpdate()` */
  static readonly ScreencomponentsV2ControllerUpdatePath = '/v2/screencomponents/{id}';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screencomponentsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screencomponentsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateScreencomponentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreencomponent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreencomponentsV2Service.ScreencomponentsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreencomponent>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screencomponentsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screencomponentsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateScreencomponentDto
    },
    context?: HttpContext
  ): Observable<WorkScreencomponent> {
    return this.screencomponentsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreencomponent>): WorkScreencomponent => r.body)
    );
  }

}
